export var SURVEY_ALLOWED_COMPONENTS = [
    "text",
    "rating",
    "checkbox",
    "tagbox",
    "radiogroup",
];
export var FORMS_EXCLUDED_TOOLBOX_ITEMS = ["paneldynamic"];
